import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["links", "template"];

  connect() {
    this.wrapperClass = this.data.get("wrapperClass") || "nested-fields";
    this.initialize_selects();
  }

  initialize_selects() {
    const selectElements = this.element.querySelectorAll(".layout-type-select");
    selectElements.forEach((selectElement) => {
      this.handle_type_change(null, selectElement);
    });
  }

  handle_type_change(event, selectElement = null) {
    let newValue, nestedFieldElement;
    if (event) {
      newValue = event.target.value;
      nestedFieldElement = event.target.parentElement;
    } else {
      newValue = selectElement.value;
      nestedFieldElement = selectElement.parentElement;
    }
    const allValues = [
      "horizontal_image",
      "horizontal2_image",
      "vertical_image",
      "vertical2_image",
      "vertical3_image",
      "content_html",
    ];

    const selectValuesMap = {
      horizontal: ["horizontal_image"],
      horizontal_horizontal: ["horizontal_image", "horizontal2_image"],
      horizontal_vertical: ["horizontal_image", "vertical_image"],
      vertical_horizontal: ["vertical_image", "horizontal_image"],
      vertical_vertical_vertical: [
        "vertical_image",
        "vertical2_image",
        "vertical3_image",
      ],
      html: ["content_html"],
    };

    if (!selectValuesMap[newValue] || selectValuesMap[newValue].length === 0) {
      alert(`Error, there is no such value: ${newValue}`);
    }

    allValues.forEach((elementId) => {
      const element = nestedFieldElement.querySelector(`#${elementId}`);
      if (element) {
        element.classList.add("hidden");
      }
    });

    selectValuesMap[newValue].forEach((elementId, idx) => {
      const element = nestedFieldElement.querySelector(`#${elementId}`);
      if (element) {
        element.classList.remove(
          "hidden",
          "order-1",
          "order-2",
          "order-3",
          "order-4",
        );
        element.classList.add(`order-${idx + 1}`);
      }
    });
  }

  add_association(event) {
    event.preventDefault();

    const positionElements = Array.from(
      this.element.querySelectorAll(
        ".nested-fields:not(.hidden) .work_row_position_input",
      ),
    );
    const nextPosition =
      Math.max(
        0,
        ...positionElements.map((element) => parseInt(element.value)),
      ) + 1;

    var content = this.templateTarget.innerHTML.replace(
      /NEW_RECORD/g,
      new Date().getTime(),
    );
    this.linksTarget.insertAdjacentHTML("beforebegin", content);
    this.initialize_selects();

    const latestWorkRow = this.linksTarget.previousElementSibling.querySelector(
      ".work_row_position_input",
    );
    latestWorkRow.value = nextPosition;
  }

  remove_association(event) {
    event.preventDefault();

    let wrapper = event.target.closest("." + this.wrapperClass);

    // New records are simply removed from the page
    if (wrapper.dataset.newRecord == "true") {
      wrapper.remove();

      // Existing records are hidden and flagged for deletion
    } else {
      wrapper.querySelector("input[name*='_destroy']").value = 1;
      wrapper.classList.add("hidden");
    }
  }
}
